import { useNavigate } from "react-router-dom"

import AddCardOutlinedIcon from '@mui/icons-material/AddCardOutlined'
import SidebarAction from '/components/sidebar-action'

const Menu = () => {

  const navigate = useNavigate()

  return (
    <div className='flex flex-row justify-end whitespace-nowrap'>
      <SidebarAction label="Subscription Plan" icon={<AddCardOutlinedIcon />} onClick={() => navigate("/billing/plan")} />
    </div>
  )
}

export default Menu
